import request from '@/utils/request'

// 链接列表
export function link_config(params = {}) {
  return request({
    url: '/tao_bao_link/link_config',
    method: 'get',
    params
  })
}
// 链接添加
export function addlink_config(data = {}) {
  return request({
    url: '/tao_bao_link/link_config',
    method: 'post',
    data
  })
}
// 链接修改
export function updatalink_config(data = {}) {
  return request({
    url: `/tao_bao_link/link_config/${data.id}`,
    method: 'put',
    data
  })
}
// 删除
export function dellink_config(id) {
  return request({
    url: `/tao_bao_link/link_config/${id}`,
    method: 'delete'
  })
}
// 公众号列表
export function wechat(params = {}) {
  return request({
    url: '/tao_bao_link/wechat',
    method: 'get',
    params
  })
}
// 数据源
export function user_action_sets(params = {}) {
  return request({
    url: '/data_report/user_action_sets',
    method: 'get',
    params
  })
}
export function newMateriallist(data = {}) {
  return request({
    url: '/sourceMaterial/storeBatch',
    method: 'post',
    data
  })
}
// 卡片账户列表
export function payoneercardlist(params = {}) {
  return request({
    url: '/payoneer_card/list',
    method: 'get',
    params
  })
}
// 卡片账户创建
export function payoneercardcreate(data = {}) {
  return request({
    url: '/payoneer_card/create',
    method: 'post',
    data
  })
}
// 卡片账户更新
export function payoneercardupdate(data = {}) {
  return request({
    url: '/payoneer_card/update',
    method: 'post',
    data
  })
}
// 批量导入卡号
export function payoneercardimport(data = {}) {
  return request({
    url: '/payoneer_card/import',
    method: 'post',
    data
  })
}
// 删除卡片账户
export function deletecard(data = {}) {
  return request({
    url: '/payoneer_card/destroy',
    method: 'post',
    data
  })
}
// adx_kafka任务列表
export function kafkalist(params = {}) {
  return request({
    url: '/adx/task/kafka/list',
    method: 'get',
    params
  })
}
// adx_kafka任务详情
export function kafkadetail(params = {}) {
  return request({
    url: '/adx/task/kafka/detail',
    method: 'get',
    params
  })
}
// adx_kafka素材下载
export function kafkadownloadMaterial(data = {}) {
  return request({
    url: '/adx/task/kafka/downloadMaterial',
    method: 'post',
    data
  })
}
// 获取选项
export function adevaluaticonfigoptions(params = {}) {
  return request({
    url: '/ad_evaluation_config/options',
    method: 'get',
    params
  })
}
// 新增配置
export function adevaluationconfigadd(data = {}) {
  return request({
    url: '/ad_evaluation_config/add',
    method: 'post',
    data
  })
}
// 配置列表
export function atlaslistrrrr(params = {}) {
  return request({
    url: '/ad_evaluation_config/list',
    method: 'get',
    params
  })
}
// 编辑配置
export function adevaluationconfigedit(data = {}) {
  return request({
    url: '/ad_evaluation_config/edit',
    method: 'post',
    data
  })
}
// 删除配置
export function adevaluationconfigdelete(data = {}) {
  return request({
    url: '/ad_evaluation_config/delete',
    method: 'post',
    data
  })
}
// 设置组长
export function adcopirw(data = {}) {
  return request({
    url: '/iaaMaterialReport/pitcher/update',
    method: 'post',
    data
  })
}
